import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BRAND } from "../../lib/constants";

const NAV = [
    { label: "Categories", href: "#categories" },
    { label: "Hospital Planning", href: "#services" },
    { label: "PharmaOps", href: "#saas" },
    { label: "Facts", href: "#facts" },
    { label: "Inquiry", href: "#inquiry" },
    { label: "Meeting", href: "#meeting" },
];

export default function Header() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="sticky top-0 z-50 bg-[#FAF9F6]/85 backdrop-blur-xl backdrop-saturate-150 border-b border-stone-200/60"
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <a
                    href="#top"
                    className="flex items-center gap-3 group"
                    data-testid="brand-logo"
                >
                    <div className="w-11 h-11 bg-white border border-stone-200 grid place-items-center p-1">
                        <img
                            src={BRAND.logo}
                            alt="Momia logo"
                            className="w-full h-full object-contain"
                        />
                    </div>
                    <div className="leading-tight">
                        <div className="font-cabinet font-bold text-ink text-[15px] tracking-tight">
                            {BRAND.name}
                        </div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500">
                            {BRAND.website}
                        </div>
                    </div>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {NAV.map((n) => (
                        <a
                            key={n.href}
                            href={n.href}
                            className="text-sm text-ink/80 hover:text-ink transition-colors"
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <a
                        href={`https://wa.me/${BRAND.whatsapp.replace("+", "")}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-ghost text-sm"
                        data-testid="header-whatsapp-link"
                    >
                        <Phone size={16} strokeWidth={1.5} />
                        <span className="font-mono">
                            {BRAND.whatsappDisplay}
                        </span>
                    </a>
                    <a
                        href="#inquiry"
                        className="btn-primary text-sm"
                        data-testid="header-cta-inquiry"
                    >
                        Request Quote
                    </a>
                </div>

                <button
                    className="lg:hidden w-10 h-10 grid place-items-center border border-stone-300"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={18} /> : <Menu size={18} />}
                </button>
            </div>

            {open && (
                <div
                    className="lg:hidden border-t border-stone-200 bg-white"
                    data-testid="mobile-nav-panel"
                >
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {NAV.map((n) => (
                            <a
                                key={n.href}
                                href={n.href}
                                onClick={() => setOpen(false)}
                                className="text-ink text-base"
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                {n.label}
                            </a>
                        ))}
                        <a
                            href="#inquiry"
                            onClick={() => setOpen(false)}
                            className="btn-primary text-sm w-full justify-center mt-2"
                            data-testid="mobile-cta-inquiry"
                        >
                            Request Quote
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
